export default {
  en: {
    'containers.user-list.table-heading.name': 'Name',
    'containers.user-list.table-heading.email': 'Email',
    'containers.user-list.table-heading.role': 'Role',
  },
};
